@use '@/styles/tokens' as *;

// Figma node 219:327388 — back link and kebab on one row, then the name block.

.header {
  display: flex;
  flex-direction: column;
  gap: var(--space-5);
}

.topRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.identity {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
}

.name {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  margin: 0;
  font-family: $font-family-heading;
  font-size: $font-size-40;
  font-weight: $font-weight-regular;
  letter-spacing: -0.03em;
  line-height: 1.1;
  color: var(--text-primary);
}

.shield {
  display: inline-flex;
  color: $color-brand-700;
}

.info {
  display: inline-flex;
  padding: 0;
  border: none;
  background: none;
  color: $color-warning-700;
  cursor: pointer;

  &:focus-visible {
    outline: none;
    border-radius: $radius-sm;
    box-shadow: var(--focus-ring);
  }
}

.subRow {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: var(--space-3);
}

.serial {
  font-size: $font-size-16;
  line-height: 1.4;
  color: var(--text-tertiary);
}

.lastSync {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: $font-size-12;
  line-height: 1.4;
  color: var(--text-muted);
}
